import React from 'react';

interface RpgSpriteProps {
  name: string;
}

const RpgSprite: React.FC<RpgSpriteProps> = ({ name }) => {
  const sprites: { [key: string]: React.ReactElement } = {
    player: (
      <svg viewBox="0 0 16 16" className="w-full h-full">
        <rect x="6" y="2" width="4" height="4" fill="#f0d5ab"/> {/* Head */}
        <rect x="5" y="6" width="6" height="5" fill="#4a4a8a"/> {/* Body */}
        <rect x="5" y="11" width="2" height="3" fill="#6b4f3a"/> {/* Left Leg */}
        <rect x="9" y="11" width="2" height="3" fill="#6b4f3a"/> {/* Right Leg */}
        <rect x="3" y="6" width="2" height="4" fill="#f0d5ab"/> {/* Left Arm */}
        <rect x="11" y="6" width="2" height="4" fill="#f0d5ab"/> {/* Right Arm */}
      </svg>
    ),
    mentor: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="6" y="1" width="4" height="4" fill="#e0e0e0"/> {/* Head */}
            <rect x="4" y="5" width="8" height="8" fill="#5a3a1a"/> {/* Robe */}
            <rect x="6" y="3" width="4" height="3" fill="#ffffff"/> {/* Beard */}
            <rect x="3" y="7" width="2" height="5" fill="#ad8b6b"/> {/* Staff */}
        </svg>
    ),
    slime: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M2 14 C 2 8, 14 8, 14 14 Z" fill="#76c476"/> {/* Body */}
            <circle cx="6" cy="11" r="1" fill="white"/> {/* Left Eye */}
            <circle cx="10" cy="11" r="1" fill="white"/> {/* Right Eye */}
            <circle cx="6" cy="11" r="0.5" fill="black"/>
            <circle cx="10" cy="11" r="0.5" fill="black"/>
        </svg>
    ),
    sword: (
        <svg viewBox="0 0 16 16" className="w-full h-full" transform="rotate(-45 8 8)">
            <rect x="7" y="1" width="2" height="10" fill="#c0c0c0"/> {/* Blade */}
            <rect x="5" y="10" width="6" height="2" fill="#8b4513"/> {/* Guard */}
            <rect x="7" y="12" width="2" height="3" fill="#654321"/> {/* Hilt */}
        </svg>
    ),
    gremlin: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="5" y="4" width="6" height="6" fill="#5a8b5a"/> {/* Head */}
            <path d="M 5 4 L 3 1 L 5 6 Z" fill="#5a8b5a"/> {/* Left Ear */}
            <path d="M 11 4 L 13 1 L 11 6 Z" fill="#5a8b5a"/> {/* Right Ear */}
            <rect x="6" y="6" width="1" height="1" fill="#ffcc00"/> {/* Left Eye */}
            <rect x="9" y="6" width="1" height="1" fill="#ffcc00"/> {/* Right Eye */}
            <rect x="6" y="8" width="4" height="1" fill="#f0f0f0"/> {/* Mouth */}
        </svg>
    ),
    goblin: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="5" y="5" width="6" height="6" fill="#3a5a3a"/>
            <path d="M 5 5 L 2 2 L 5 8 Z" fill="#3a5a3a"/>
            <path d="M 11 5 L 14 2 L 11 8 Z" fill="#3a5a3a"/>
            <rect x="6" y="7" width="1" height="1" fill="yellow"/>
            <rect x="9" y="7" width="1" height="1" fill="yellow"/>
            <rect x="6" y="11" width="4" height="3" fill="#4b3b2b"/>
        </svg>
    ),
    ghost: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M4 14 C 4 8, 12 8, 12 14 L 10 12 L 8 14 L 6 12 Z" fill="#e0e0e0"/>
            <circle cx="6" cy="9" r="1" fill="black"/>
            <circle cx="10" cy="9" r="1" fill="black"/>
        </svg>
    ),
    orc: (
         <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="4" y="3" width="8" height="7" fill="#6b8e23"/>
            <rect x="5" y="10" width="6" height="4" fill="#8b4513"/>
            <rect x="7" y="5" width="1" height="1" fill="red"/>
            <rect x="8" y="5" width="1" height="1" fill="red"/>
            <rect x="5" y="8" width="1" height="2" fill="white"/>
            <rect x="10" y="8" width="1" height="2" fill="white"/>
        </svg>
    ),
    dragon: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M4 14 L8 6 L12 14 L14 12 L10 4 L14 2 L8 8 L2 2 L6 4 L2 12 Z" fill="#a0a0a0"/>
            <rect x="7" y="4" width="2" height="2" fill="#c0c0c0"/>
            <rect x="8" y="5" width="1" height="1" fill="gray"/>
        </svg>
    ),
    bat: (
      <svg viewBox="0 0 16 16" className="w-full h-full">
        <path d="M8 4 C 4 2, 2 8, 8 12 C 14 8, 12 2, 8 4 Z" fill="#4a4a4a"/>
        <circle cx="7" cy="6" r="0.5" fill="red"/>
        <circle cx="9" cy="6" r="0.5" fill="red"/>
      </svg>
    ),
    crab: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="4" y="6" width="8" height="6" rx="2" fill="#e57373"/>
            <path d="M4 7 L 1 4 L 3 7 Z" fill="#c62828"/>
            <path d="M12 7 L 15 4 L 13 7 Z" fill="#c62828"/>
            <rect x="5" y="12" width="1" height="3" fill="#e57373"/>
            <rect x="7" y="12" width="1" height="3" fill="#e57373"/>
            <rect x="10" y="12" width="1" height="3" fill="#e57373"/>
            <rect x="6" y="7" width="1" height="1" fill="white"/>
            <rect x="9" y="7" width="1" height="1" fill="white"/>
        </svg>
    ),
    golem: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="5" y="2" width="6" height="5" rx="1" fill="#8d8d8d"/>
            <rect x="4" y="7" width="8" height="6" rx="1" fill="#a4a4a4"/>
            <rect x="1" y="6" width="4" height="5" rx="1" fill="#a4a4a4"/>
            <rect x="11" y="6" width="4" height="5" rx="1" fill="#a4a4a4"/>
            <rect x="7" y="4" width="2" height="1" fill="#ffeb3b"/>
        </svg>
    ),
    dragon_awake: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M4 14 L8 6 L12 14 L14 12 L10 4 L14 2 L8 8 L2 2 L6 4 L2 12 Z" fill="#d04040"/>
            <rect x="7" y="4" width="2" height="2" fill="#d95a5a"/>
            <rect x="8" y="5" width="1" height="1" fill="yellow"/>
        </svg>
    ),
    shield: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M8 1 L 2 4 L 2 9 C 2 12, 8 15, 8 15 C 8 15, 14 12, 14 9 L 14 4 Z" fill="#cd7f32"/>
            <path d="M8 2 L 3 5 L 3 9 C 3 11, 8 14, 8 14 C 8 14, 13 11, 13 9 L 13 5 Z" fill="#c0c0c0"/>
        </svg>
    ),
    sunstone: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <circle cx="8" cy="8" r="6" fill="#ffeb3b"/>
            <path d="M8 2 L 9 5 L 12 6 L 9 7 L 8 10 L 7 7 L 4 6 L 7 5 Z" fill="#fff59d"/>
        </svg>
    ),
    spider: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="5" y="5" width="6" height="6" fill="#3a3a3a"/> {/* Body */}
            <rect x="6" y="4" width="1" height="1" fill="red"/>
            <rect x="9" y="4" width="1" height="1" fill="red"/>
            {/* Legs */}
            <rect x="3" y="4" width="2" height="1" fill="#3a3a3a"/>
            <rect x="3" y="7" width="2" height="1" fill="#3a3a3a"/>
            <rect x="3" y="10" width="2" height="1" fill="#3a3a3a"/>
            <rect x="11" y="4" width="2" height="1" fill="#3a3a3a"/>
            <rect x="11" y="7" width="2" height="1" fill="#3a3a3a"/>
            <rect x="11" y="10" width="2" height="1" fill="#3a3a3a"/>
        </svg>
    ),
    skeleton: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="6" y="2" width="4" height="4" fill="#f0f0f0"/> {/* Head */}
            <rect x="7" y="4" width="1" height="1" fill="black"/> {/* Eye */}
            <rect x="8" y="4" width="1" height="1" fill="black"/> {/* Eye */}
            <rect x="7" y="6" width="2" height="5" fill="#f0f0f0"/> {/* Torso */}
            <rect x="5" y="6" width="6" height="1" fill="#f0f0f0"/> {/* Ribs */}
            <rect x="5" y="8" width="6" height="1" fill="#f0f0f0"/> {/* Ribs */}
            <rect x="7" y="11" width="1" height="3" fill="#f0f0f0"/> {/* Leg */}
            <rect x="8" y="11" width="1" height="3" fill="#f0f0f0"/> {/* Leg */}
        </svg>
    ),
    treant: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="5" y="1" width="6" height="6" fill="#2e7d32"/> {/* Leaves */}
            <rect x="6" y="6" width="4" height="8" fill="#6d4c41"/> {/* Trunk */}
            <rect x="3" y="7" width="3" height="1" fill="#6d4c41"/> {/* Arm */}
            <rect x="10" y="7" width="3" height="1" fill="#6d4c41"/> {/* Arm */}
            <rect x="7" y="8" width="1" height="1" fill="#ffc107"/> {/* Eye */}
            <rect x="8" y="8" width="1" height="1" fill="#ffc107"/> {/* Eye */}
        </svg>
    ),
    wisp: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <circle cx="8" cy="8" r="4" fill="#90caf9"/>
            <circle cx="8" cy="8" r="2" fill="#e3f2fd"/>
            <circle cx="7.5" cy="7.5" r="0.5" fill="black"/>
            <circle cx="8.5" cy="7.5" r="0.5" fill="black"/>
        </svg>
    ),
    mire_lurker: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M2 14 C 2 10, 14 10, 14 14 Z" fill="#4e342e"/> {/* Shell */}
            <rect x="5" y="8" width="6" height="3" fill="#795548"/> {/* Body */}
            <rect x="7" y="7" width="1" height="1" fill="#fdd835"/> {/* Eye */}
            <rect x="8" y="7" width="1" height="1" fill="#fdd835"/> {/* Eye */}
        </svg>
    ),
    guardian: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="4" y="1" width="8" height="14" fill="#78909c"/> {/* Body */}
            <rect x="3" y="5" width="10" height="2" fill="#607d8b"/> {/* Shoulders */}
            <rect x="7" y="5" width="2" height="2" fill="#ffc107"/> {/* Gem */}
            <rect x="6" y="2" width="4" height="3" fill="#546e7a"/> {/* Head */}
        </svg>
    ),
    frost_wolf: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="4" y="6" width="8" height="5" fill="#e0f7fa"/> {/* Body */}
            <rect x="9" y="4" width="4" height="3" fill="#b3e5fc"/> {/* Head */}
            <rect x="12" y="5" width="1" height="1" fill="#01579b"/> {/* Eye */}
            <rect x="4" y="11" width="1" height="2" fill="#e0f7fa"/>
            <rect x="6" y="11" width="1" height="2" fill="#e0f7fa"/>
            <rect x="9" y="11" width="1" height="2" fill="#e0f7fa"/>
            <rect x="11" y="11" width="1" height="2" fill="#e0f7fa"/>
        </svg>
    ),
    ice_elemental: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <path d="M8 1 L 12 6 L 10 7 L 14 11 L 8 15 L 2 11 L 6 7 L 4 6 Z" fill="#80deea"/>
            <path d="M8 3 L 10 6 L 8 7 L 6 6 Z" fill="#e0f7fa"/>
            <rect x="7" y="4" width="2" height="1" fill="#006064"/>
        </svg>
    ),
    yeti: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="3" y="2" width="10" height="12" fill="white"/>
            <rect x="2" y="6" width="12" height="2" fill="white"/>
            <rect x="6" y="5" width="1" height="1" fill="black"/>
            <rect x="9" y="5" width="1" height="1" fill="black"/>
            <rect x="6" y="7" width="4" height="1" fill="#8d6e63"/>
        </svg>
    ),
    forge_master: (
        <svg viewBox="0 0 16 16" className="w-full h-full">
            <rect x="4" y="4" width="8" height="10" fill="#616161"/> {/* Body */}
            <rect x="5" y="2" width="6" height="3" fill="#424242"/> {/* Head */}
            <rect x="6" y="3" width="1" height="1" fill="#ff9800"/>
            <rect x="9" y="3" width="1" height="1" fill="#ff9800"/>
            <rect x="2" y="6" width="3" height="6" fill="#e65100"/> {/* Hammer */}
            <rect x="3" y="5" width="1" height="8" fill="#4e342e"/> {/* Handle */}
        </svg>
    ),
  };

  const sprite = sprites[name];

  if (!sprite) return <div className="w-32 h-32 bg-gray-800 rounded animate-pulse" />;
  
  return <div className="w-32 h-32 mx-auto my-4 transition-opacity duration-500">{sprite}</div>;
};

export default RpgSprite;
